import React from 'react';
import { secureStorage_getItem } from '../../utility/secureStorage';

class CookieDrop extends React.Component {
    componentDidMount() {
        window.addEventListener('load', this.handleLoad)
    }

    handleLoad = () => {
        var response = {
            source: 'vlomni-customerui',
            payload: {
                accesstoken: secureStorage_getItem('accesstoken')
            }
        }

        window.parent.postMessage(response, "*");
    }

    render() {
        return (
            <div>
            </div>
        )
    }
}

export default CookieDrop;